import Package from "../../../../../package.json" with { type: "json" }

/**
 * @description
 *	Some MIME-Types.
 */
export default class MIMEType {
	// Standard.
	public static readonly HTML = "text/html"
	public static readonly JSON = "application/json"

	// Vendor specific.
	public static readonly BIOMETRY_JSON = `application/vnd.${Package.metadata.rdnn}-v${Package.version}+json`
}
